import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext.js';

// Компонент для защищенных роутов
const ProtectedRoute = ({ 
  children, 
  requiredRole = null, 
  requiredPermission = null,
  minRole = null,
  requiredModule = null,
  redirectTo = '/login',
  fallback = null 
}) => {
  const { isAuthenticated, loading, user, hasRole, hasPermission, hasMinRole, hasModuleAccess, modulesLoading } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяем авторизацию или модули
  if (loading || (requiredModule && modulesLoading)) {
    return fallback || (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#0a0a0a'
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} 
          size="large"
        />
      </div>
    );
  }

  // Если не авторизован, редиректим на логин
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Проверка конкретной роли
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Проверка минимальной роли
  if (minRole && !hasMinRole(minRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Проверка конкретного права
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Проверка модуля
  if (requiredModule && !hasModuleAccess(requiredModule)) {
    // Для дашборда перенаправляем на профиль, для остальных - на forbidden
    const redirectPath = requiredModule === 'dashboard' ? '/profile' : '/forbidden';
    return <Navigate to={redirectPath} replace />;
  }

  // Все проверки пройдены, показываем защищенный контент
  return children;
};

export default ProtectedRoute;
